import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { ToastProvider } from "@/context/ToastContext";
import Layout from "@/components/Layout";
import { RequireAuth } from "@/components/RequireAuth";

import { Login, Register, AuthCallback, AdminLogin } from "@/pages/Auth";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import Linking from "@/pages/Linking";
import Economy from "@/pages/Economy";  // mounted as a tab inside PalGame; redirected from /economy
import Shop from "@/pages/Shop";
import PalGame from "@/pages/PalGame";
import Gambling from "@/pages/Gambling";
import Lookup from "@/pages/Lookup";
import PalDetail from "@/pages/PalDetail";
import MapPage from "@/pages/MapPage";
import Towers from "@/pages/Towers";
import Breeding from "@/pages/Breeding";
import Skills from "@/pages/Skills";
import Builder from "@/pages/Builder";
import Giveaways from "@/pages/Giveaways";
import Support from "@/pages/Support";
import Appeal from "@/pages/Appeal";
import ServerSettings from "@/pages/ServerSettings";
import TechTree from "@/pages/TechTree";
import Admin from "@/pages/Admin";
import Planner from "@/pages/Planner";
import Raids from "@/pages/Raids";
import Pvp from "@/pages/Pvp";

function HomeGate() {
  // Public landing page is reachable at `/` for everyone (logged-in or not).
  // Layout is rendered so the top nav stays visible.
  return (
    <Layout>
      <Home />
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            {/* Public auth pages (no Layout) */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/auth/callback" element={<AuthCallback />} />

            {/* Public map (no auth required, but Layout helps nav) */}
            <Route path="/map" element={<Layout><MapPage /></Layout>} />
            <Route path="/raids" element={<Layout><Raids /></Layout>} />
            <Route path="/pvp" element={<Layout><Pvp /></Layout>} />
            <Route path="/lookup" element={<Layout><Lookup /></Layout>} />
            <Route path="/paldex/:slug" element={<Layout><PalDetail /></Layout>} />
            <Route path="/towers" element={<Layout><Towers /></Layout>} />
            <Route path="/breeding" element={<Layout><Breeding /></Layout>} />
            <Route path="/skills" element={<Layout><Skills /></Layout>} />
            <Route path="/builder" element={<Layout><Builder /></Layout>} />
            <Route path="/appeal" element={<Layout><Appeal /></Layout>} />
            <Route path="/server-settings" element={<Layout><ServerSettings /></Layout>} />
            <Route path="/tech-tree" element={<Layout><TechTree /></Layout>} />

            {/* Protected app */}
            <Route path="/dashboard" element={<RequireAuth><Layout><Dashboard /></Layout></RequireAuth>} />
            <Route path="/linking" element={<RequireAuth><Layout><Linking /></Layout></RequireAuth>} />
            <Route path="/economy" element={<RequireAuth><Layout><Navigate to="/palgame?tab=economy" replace /></Layout></RequireAuth>} />
            <Route path="/shop" element={<RequireAuth><Layout><Shop /></Layout></RequireAuth>} />
            <Route path="/palgame" element={<RequireAuth><Layout><PalGame /></Layout></RequireAuth>} />
            <Route path="/pal-care" element={<Navigate to="/palgame?tab=care" replace />} />
            <Route path="/gambling" element={<RequireAuth><Layout><Gambling /></Layout></RequireAuth>} />
            <Route path="/giveaways" element={<RequireAuth><Layout><Giveaways /></Layout></RequireAuth>} />
            <Route path="/planner" element={<RequireAuth><Layout><Planner /></Layout></RequireAuth>} />
            <Route path="/support" element={<RequireAuth><Layout><Support /></Layout></RequireAuth>} />
            <Route path="/admin/*" element={<RequireAuth admin><Layout><Admin /></Layout></RequireAuth>} />

            <Route path="/" element={<HomeGate />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
